

  <section style="top: 350px;overflow-y: scroll;height: 100% !important;">

  <div class="wrapper">
    <label class="diagnostic-label"  style="width: 90%;">Progress Notes</label>

  <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 6%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
  <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 76%;width: 6%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
  <button type="button" class="add-boutton" style="left: 83%;" name="Add" [disabled]="disablepharnacy" (click)="openDialog()">Add</button>
  </div>


<BR>
<BR>
<div style="width: 60%;">
 <table style="left: 50px;width: 100%;">
  <tr *ngFor="let item of progressnoteList; let i = index" style="font-size: {{wk_fontsize}}; text-align: left;">
    <td>
      <div style="display: flex; justify-content: space-between; align-items: center;width: 100%;">
        <div>
           <label style="font-weight: bold;">{{item.progdate}} {{item.username}}</label>
        </div>
        <div>
          <button class="fa fa-pencil" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)="EditProgressNotes(item)"></button>
          <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
        </div>
      </div>
      <label><pre>{{item.prognotes}}</pre></label>
      <br>
      <br>
    </td>
  </tr>
</table>
</div>
</section>

